import '@elevationscu/ui-component-lib/dist/style.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import AppWithRouterAccess from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

if (process.env.REACT_APP_ATTACH_GOOGLE_TAG === 'true') {
  const GA_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_P42_ID;
  if (GA_ID) {
    // load gtag.js
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script1);

    // inline GA init
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(script2);
  }
}

root.render(
  <React.StrictMode>
    <AppWithRouterAccess />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
